import { STATUS } from '../status.constants';

export enum UserActionType {
  score = "score",
  removeScore = "removeScore",
  compositeScore = "compositeScore",
  removeCompositeScore = "removeCompositeScore"
}

export interface UserSessionParams {
  actionType: UserActionType;
  payload: object;
  loggedAt: Date
}

export type UserActionAckStatus = typeof STATUS[keyof typeof STATUS];

// One recordUserSession / recordTokenUserSession result, as selected by RECORD_USER_SESSION.
export interface IUserActionAck {
  actionType?: string | null;
  loggedAt: Date | string;
  status?: UserActionAckStatus | string | null;
  succeeded?: boolean | null;
  refusalReason?: string | null;
}

export interface IUserSessionStore {
  // User sessions by user id
  userSessions: Record<string, IUserSession[]>
}